import React, { useEffect, useState, memo, useCallback } from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { FaBell, FaEdit } from "react-icons/fa";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import EditOffIcon from "@mui/icons-material/EditOff";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import dayjs from "dayjs";
import api from "../api/api";
import AddRoom from "./AddRoom";
import DynamicTime from "./Dynamictime";
import { Backdrop, CircularProgress } from "@mui/material";
import CropFreeIcon from '@mui/icons-material/CropFree';
import BrainymedLogo from '../../src/assets/cards/shared image.png';
import DarkBrainymedLogo from '../../src/assets/cards/shared_image-removebg-preview.png';
import ToastMessage from "../utils/mui/righttoptoast";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Unassignp from "./unassignp";
import PateintConfirm from "./PateintConfirm";
import SettingsIcon from '@mui/icons-material/Settings';
import Settings from "./Settings";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Swaproom from "./Swaproom";
import { Emergency } from "@mui/icons-material";
import CenterToastMessage from "../utils/mui/Centertoptoast";
import { getPracticeId } from "../config/practice";
import { openHelpRequests, closeRoomHelp } from "./roomHelp";
// Memoize the AddRoom component to prevent unnecessary rerenders
const MemoizedAddRoom = memo(AddRoom);

const Waitinghome = () => {
  const [initialRenderComplete, setInitialRenderComplete] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newRoomName, setNewRoomName] = useState('');
  const [newRoomStatus, setNewRoomStatus] = useState('');
  const [editingRoom, setEditingRoom] = useState(null);
  const [toggleroom, setToggleroom] = useState(false);
  const [AddedRoom, setAddedRoom] = useState({ type: '', room: '' });
  const practiseid = getPracticeId();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
  });
  const [roomExistsError, setRoomExistsError] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [RoomData, setRoomData] = useState({ type: '', room: '' });
  const [RoomCardData, setRoomCardData] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState('success');
  const [openPatients, setOpenPatients] = useState(false);
  const [Patients, setPatients] = useState([]);
  const [modalPateintOpen, setModalPateintOpen] = useState(false);
  const [currentRoomPatient, setCurrentRoomPatient] = useState(null);
  const [selectedPatientInroom, setSelectedPatientInroom] = useState(null);
  const [gridWidth, setGridWidth] = useState(0); 
  const [roomSizing,setRoomSizing]=useState(null);
  const [cols, setCols] = useState(window.innerWidth >= 1290 ? 28 : window.innerWidth >= 1024 ? 16 : 12);
  const [settings,setSettings]=useState(null);
  const [settingsModal,setSettingsModal]=useState(false);
  const [threshold, setThreshold] = useState(null);
  const [coloravalaible ,setColorAvailable]=useState('');
  const [coloroccupied, setColorOccupied] = useState('');
  const [getavailable,setAvailable]=useState('#59B0FF99');
  const [getoccupied,setOccupied]=useState('#E17954');
  const [previousRoom, setPreviousRoom] = useState(null);
  const [previousPatient, setPreviousPatient] = useState(null);
  const [patientsWithEmergency, setPatientsWithEmergency] = useState([]);
  const [toastCenterMessage, setToastCenterMessage] = useState(''); // Message to show in toast
  const [toastCenterSeverity, setToastCenterSeverity] = useState('info'); // Severity can be 'info', 'error', 'success', 'warning'
  const [openCenterToast, setOpenCenterToast] = useState(false); // Control the visibility of the toast
  const [alarmReset,setAlarmReset]=useState(true);
  const [darkMode, setDarkMode] = useState(() => {
  const savedMode = localStorage.getItem('darkMode');
  
  return savedMode ? JSON.parse(savedMode) : false;
  });
  const [hide,setHide]=useState('');
  const [fontSize, setFontSize] = useState('md');
  const [containerAlignment, setContainerAlignment] = useState('bottom');
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const handleDarkModeChange = (event) => {
    setDarkMode(event.target.value === 'true');
  };

  const enterFullscreen = () => {
    const docEl = document.documentElement;
    if (docEl.requestFullscreen) {
      docEl.requestFullscreen();
    } else if (docEl.mozRequestFullScreen) { // Firefox
      docEl.mozRequestFullScreen();
    } else if (docEl.webkitRequestFullscreen) { // Chrome, Safari and Opera
      docEl.webkitRequestFullscreen();
    } else if (docEl.msRequestFullscreen) { // IE/Edge
      docEl.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) { // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) { // Chrome, Safari, Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) { // IE/Edge
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  // Function to handle closing the toast
  const handleToastCenterClose = () => {
    setOpenCenterToast(false); // Close the toast
  };
  // Check fullscreen status on component mount and update state
  useEffect(() => {
    const handleFullscreenChange = () => {
      if (document.fullscreenElement) {
        setIsFullscreen(true);
      } else {
        setIsFullscreen(false);
      }
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  const handleToastClose = () => {
    setOpenToast(false);
  };

  useEffect(() => {
    if (rooms.length === 1 && !selectedRoom) {
      setSelectedRoom(rooms[0].id); // Auto-select the room if there's only one
    }
  }, [rooms, selectedRoom]);

  const handleRoomClick = (room,e) => {
    if (e) {
      e.stopPropagation(); // Prevent event from bubbling up
    }
    console.log('PreviousPateint',previousPatient)
    if (previousRoom && previousPatient && room.patients.length === 0 && !isEditing ) {
      // Call handleResignRoom with the details of the previous room's patient and the next room
       handleResignRoom({
        appointmentid: previousPatient.appointmentid,
        pateintID: previousPatient.patientid,
        roomName: room.name,  // The room the patient is being moved to
        appointmentdate: previousPatient.startdate,
        visit_confirmation: previousPatient.visitconfirmation,
      });
      // Optionally, you can update state or call any other functions needed after this operation
    }
  
    // Now handle the room selection
    setRoomSizing(room);
    if (selectedRoom === room.id) {
      // Deselect if the room is already selected
      setSelectedRoom(null);
      setPreviousRoom(null);  // Clear previous room if deselected
      setPreviousPatient(null);  // Clear previous patient if deselected
    } else {
      // Select the room
      setSelectedRoom(room.id);
      
      // If the selected room has a patient, store the patient data
      if (room.patients && room.patients.length > 0) {
        const matchedPatient = room.patients[0];  // Assuming one patient per room
        setPreviousRoom(room);
        setPreviousPatient(matchedPatient);  // Store the patient data
      }
  
      // Find the room from the fetched data that matches the clicked room name
      const matchedRoom = RoomCardData.find(r => r.room === room.name);
      if (matchedRoom) {
        // If a match is found, update the RoomData state
        setRoomData({
          type: matchedRoom.type,
          room: matchedRoom.room
        });
      }
    }
  };

  

  const handleUpdateRoomSize = async ({ RoomSizing }) => {
    // Validate that all required fields are present and handle x or y being 0
    if (
      !RoomSizing?.name ||
      RoomSizing?.x == null || // This allows 0 as a valid value
      RoomSizing?.y == null || // This allows 0 as a valid value
      RoomSizing?.w == null ||
      RoomSizing?.h == null
    ) {
      console.error("Invalid RoomSizing data");
      return;
    }
    const widthData = RoomSizing.w < 2 ? 2 : RoomSizing.w;  // If w < 2, set to 2
  const heightData = RoomSizing.h < 2 ? 2 : RoomSizing.h; // If h < 2, set to 2
    const payload = {
      roomno: RoomSizing.name, // Room number
      x_pos: RoomSizing.x, // X position
      y_pos: RoomSizing.y, // Y position
      width: widthData, // Width of the room
      height: heightData // Height of the room
    };
  
    try {
      const response = await api.put(`/v1/${practiseid}/rooms/updt_rm_size`, payload);
      if (response.status === 200) {
        // Handle success (optional)
      } else {
        console.error("Failed to update room size");
      }
    } catch (error) {
      console.error("Error updating room size:", error);
    }
  };
  
  
  const debounce = (fn, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  };
  
  const debouncedUpdate = useCallback(
    debounce((roomSizing) => handleUpdateRoomSize({ RoomSizing: roomSizing }), 300),
    []
  );
  
  useEffect(() => {
    if (
      roomSizing?.name &&
      (roomSizing?.x != null) && // Allows 0 as a valid value
      (roomSizing?.y != null) && // Allows 0 as a valid value
      roomSizing?.w != null &&
      roomSizing?.h != null
    ) {
      debouncedUpdate(roomSizing);
    } else {
      console.warn("RoomSizing is invalid, skipping update.");
    }
  }, [roomSizing]);
  
  
  
  // Log the updated RoomData whenever it changes
  useEffect(() => {
    console.log("Updated RoomData:", RoomData);
  }, [RoomData]);

  // Add this useEffect to mark when initial render is complete
  useEffect(() => {
    // Set a small timeout to ensure layout stabilizes
    const timer = setTimeout(() => {
      setInitialRenderComplete(true);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Skip during initial render
    if (!initialRenderComplete) return;
    
    // After patient-related API operations complete, stabilize the layout
    const stabilizeLayout = async () => {
      // Get current positions 
      const currentPositions = rooms.map(room => ({
        id: room.id,
        name: room.name,
        x: room.x,
        y: room.y,
        w: room.w,
        h: room.h
      }));
      
      // Wait for any async operations to complete
      await new Promise(resolve => setTimeout(resolve, 50));
      
      // Apply positions back if they've changed
      setRooms(prevRooms => {
        const needsUpdate = prevRooms.some((room, i) => {
          const pos = currentPositions.find(p => p.id === room.id);
          return pos && (pos.x !== room.x || pos.y !== room.y);
        });
        
        if (needsUpdate) {
          return prevRooms.map(room => {
            const pos = currentPositions.find(p => p.id === room.id);
            if (pos) {
              return {
                ...room,
                x: pos.x,
                y: pos.y,
                w: pos.w,
                h: pos.h
              };
            }
            return room;
          });
        }
        return prevRooms;
      });
    };
    
    stabilizeLayout();
  }, [data.length, openPatients, modalPateintOpen, initialRenderComplete]); // Triggers after patient changes

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingRoom(null);
    setRoomExistsError(false);
  };

  const handleAddRoom = () => {
    const roomExists = rooms.some((room) => room.name.toLowerCase() === newRoomName.toLowerCase());
    if (roomExists) {
      setRoomExistsError(true); // Show error message if room exists
      return; // Do not proceed with adding the room
    }

    const newRoom = {
      id: rooms.length + 1,
      name: newRoomName,
      is_active: newRoomStatus,
      x: 0,
      y: 0,
      h: 2,
      w: 2,
      patients: [], // Initially no patient in the room
    };
    setRooms([...rooms, newRoom]);
    closeModal();
  };

  const handleSaveEdit = async () => {
    try {
      // Store the current positions of the room being edited
      const currentPositions = rooms.find(room => room.id === editingRoom.id);
      
      const response = await api.put(`/v1/${practiseid}/rooms/updt_rm_label`, {
        new_roomno: newRoomName.toUpperCase(),
        old_roomno: editingRoom.name.toUpperCase(),
        status: newRoomStatus
      });
      
      if (response.status === 200) {
        // Update rooms while carefully preserving the exact position
        setRooms(prevRooms => prevRooms.map(room => 
          room.id === editingRoom.id
            ? { 
                ...room,
                name: newRoomName, 
                is_active: newRoomStatus,
                // Keep the exact original positions
                x: currentPositions.x,
                y: currentPositions.y,
                w: currentPositions.w,
                h: currentPositions.h
              }
            : room
        ));
        
        closeModal();
        setToastMessage('Room Edited Successfully!');
        setToastSeverity('success');
        setOpenToast(true);
        setTimeout(() => {
          setOpenToast(false);  
        }, 2000);
        // Use setTimeout to delay the fetch operation
        setTimeout(() => {
          fetchRoomData();
        }, 300);
      } else {
        console.error("Failed to update room name");
        setToastMessage("Room name edit failed!");
        setToastSeverity("error");
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Error updating room name:", error);
    }
  };
  

  // IMPORTANT: Modified to prevent propagation and unnecessary rerenders
  const handleEditRoom = (room, e) => {
    if (e) {
      e.stopPropagation(); // Prevent event from bubbling up
    }
    
    // Only update state if we're editing a different room or not currently editing
    if (!editingRoom || editingRoom.id !== room.id) {
      // Store exact room data including position
      setEditingRoom({...room});
      setNewRoomName(room.name);
      setNewRoomStatus(room.is_active);
      openModal();
    }
  };

  // Update room positions dynamically
  const onLayoutChange = (newLayout) => {
    // Update positions during drag or resize events
    setRooms((prevRooms) => {
      const updatedRooms = prevRooms.map((room) => {
        const layoutItem = newLayout.find((item) => item.i === room.id.toString());
        if (layoutItem) {
          return {
            ...room,
            x: layoutItem.x,
            y: layoutItem.y,
            w: layoutItem.w,
            h: layoutItem.h
          };
        }
        return room;
      });
      return updatedRooms;
    });
  };
  
  // Call this when drag or resize ends to ensure the layout state is updated
  const onDragStop = (newLayout) => {
    // This ensures layout positions are updated even when dragging ends
    onLayoutChange(newLayout);
  };
  
  const onResizeStop = (newLayout) => {
    // Similarly, update the layout when resizing stops
    onLayoutChange(newLayout);
  };
  

  const toggleEditingMode = (e) => {
    e.stopPropagation()
    setIsEditing(!isEditing);
    setToggleroom(!isEditing);  // Sync toggleroom with isEditing
  };

  const handlePatientClick = (patient) => {
    // Store current room positions before making changes
    const roomPositionsSnapshot = rooms.map(room => ({...room}));
    
    if (selectedPatientId === patient.id) {
      setSelectedPatientId(null);
    } else {
      setSelectedPatientId(patient.id);
    }
  
    if (selectedRoom !== null) {
      const roomToUpdate = rooms.find((room) => room.id === selectedRoom);
  
      if (roomToUpdate.is_active === "N") {
        setToastMessage('Room inactive');
        setToastSeverity('error');
        setOpenToast(true);
        return;
      }
  
      if (roomToUpdate.patients && roomToUpdate.patients.length > 0) {
        setModalPateintOpen(true);
        setCurrentRoomPatient(roomToUpdate.patients[0]);
        setSelectedPatientInroom(patient);
      } else {
        const updatedRooms = rooms.map((room) => {
          if (room.id === selectedRoom) {
            const updatedPatients = room.patients ? [...room.patients, patient] : [patient];
            const newHeight = Math.max(room.h, Math.ceil(updatedPatients.length / 2));
            const newWidth = Math.max(room.w, Math.ceil(updatedPatients.length / 2));
  
            return {
              ...room,
              patients: updatedPatients,
              h: newHeight,
              w: newWidth,
              // Explicitly preserve x,y position
              x: room.x,
              y: room.y
            };
          }
          // Explicitly preserve all other rooms' positions too
          return {...room};
        });
  
        setRooms(updatedRooms);
  
        const updatedPatients = data.filter((p) => p.id !== patient.id);
        setData(updatedPatients);
        console.log(patient,'selecteap')
        handleResignRoom({
          appointmentid: patient.appointmentid,
          roomName: AddedRoom.room || RoomData.room,
          roomType: AddedRoom.type || RoomData.type,
          pateintID: patient.patientid,
          appointmentdate:patient.startdate
        });
      }
    }
  };

  const fetchRoomData = async () => {
    try {
      // Store current room positions before fetching
      const currentRoomPositions = new Map();
      rooms.forEach(room => {
        // Store using both name and id as keys for better matching
        currentRoomPositions.set(room.name, {
          id: room.id,
          x: room.x,
          y: room.y,
          w: room.w,
          h: room.h,
          patients: room.patients || []
        });
        currentRoomPositions.set(room.id, {
          name: room.name,
          x: room.x,
          y: room.y,
          w: room.w,
          h: room.h,
          patients: room.patients || []
        });
      });
      
      const response = await api.get(`/v1/${practiseid}/rooms/get`);
      if (response.status === 200) {
        const roomData = response.data;
        setRoomCardData(roomData);
  
        // Carefully preserve positions
        const updatedRooms = roomData.map((room) => {
          // Try to find existing position by name first
          const existingPositionByName = currentRoomPositions.get(room.room);
          // If not found by name, try by id
          const existingPositionById = currentRoomPositions.get(room.id);
          const existingPosition = existingPositionByName || existingPositionById;
          
          return {
            id: room.id,
            name: room.room,
            is_active: room.is_active,
            // Use existing position with fallbacks
            x: existingPosition?.x ?? room.x_pos ?? 0,
            y: existingPosition?.y ?? room.y_pos ?? 0,
            h: existingPosition?.h ?? room.height ?? 2,
            w: existingPosition?.w ?? room.width ?? 2,
            // Preserve existing patients if any
            patients: existingPosition?.patients || []
          };
        });
        
        // Use batch update to minimize rerenders
        setRooms(updatedRooms);
 
      } else {
        setRoomCardData([]);
        setRooms([]);
      }
    } catch (error) {
      console.error("Error fetching rooms:", error);
    }
  };

  useEffect(() => {
    fetchRoomData(); // Fetch room data when the component mounts or the practiseid changes
  }, [practiseid]);

  const fetchSignIndata = async () => {
    if (!RoomCardData.length) {
      console.log("RoomCardData is empty, skipping fetchSignIndata.");
      return; // Don't proceed if rooms are not yet fetched
    }

    const dateRange = selectedDateRange;
    const formattedStartDate = dayjs(dateRange.startDate).format("YYYY-MM-DD");
    const formattedEndDate = dayjs(dateRange.endDate).format("YYYY-MM-DD");

    try {
      // setLoading(true);
      let response = await api.post(`/v1/${practiseid}/checkin/future/get`, {
        stdate:formattedStartDate,
        eddate: formattedEndDate ,
      });

      const roomMap = new Map();

      // Populate roomMap with rooms from RoomCardData
      RoomCardData.forEach(room => {
        roomMap.set(room.room, {
          id: room.id,
          name: room.room,
          is_active: room.is_active,
          x: room.x_pos,
          y:  room.y_pos,
          h: room.height,
          w: room.width,
          patients: []
        });
      });

      if (response.status === 200) {

        response.data.forEach(patient => {
          if (["Checked Out", "Cancelled", "Rescheduled"].includes(patient.visit_confirmation)) {
            return;
          }
          const roomKey = patient.room_no;
          if (roomMap.has(roomKey)) {
            roomMap.get(roomKey).patients.push({
              id: patient.patientid,
              firstname: patient.firstname,
              lastname: patient.lastname,
              patientid: patient.patientid,
              gender: patient.gender,
              purpose: patient.purpose,
              notes: patient.notes,
              rowid: patient.id,
              roomno: patient.room_no,
              startdate:patient.startdate,
              visitconfirmation:patient.visit_confirmation,
              signintime:patient.signintime?.RoomAssignTime,
              alarmtime:patient.signintime?.alarm_alert,
              contact: {
                phone: patient.phone,
                email: patient.email
              },
              appointmentid: patient.appointmentid,
              token: patient.token,
              insurance: patient.insurancename,
              provider: patient.linked_provider,
              emergencyalert:patient.signintime?.emergency_alert,
              helprequest:patient.signintime?.help_request,
              providercheck:patient.signintime?.provider_check,
              providerfirstname:patient.provider?.FIRST,
              providerlastname:patient.provider?.Last
            });
          }
        });
        
        // Convert Map to Array and preserve positions from previous state
        const existingRooms = Array.from(roomMap.values()).map(newRoom => {
          // Try to find matching room in current state to preserve position
          const existingRoom = rooms.find(room => room.name === newRoom.name);
          if (existingRoom) {
            return {
              ...newRoom,
              x: existingRoom.x,
              y: existingRoom.y,
              w: existingRoom.w,
              h: existingRoom.h
            };
          }
          return newRoom;
        });

        // Adjust size for rooms with multiple patients
        existingRooms.forEach(room => {
          const patientCount = room.patients.length;
          if (patientCount > 1) {
            room.h = 2;
            room.w = 2;
          }
          if (patientCount > 2) {
            room.h = 3;
            room.w = 2;
          }
        });

        setData(response.data);
        setRooms(existingRooms); // Update rooms with patient data while preserving positions
      } else {
        setData([]);
        console.log("No patient data found, setting empty state.");
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
  const interval = setInterval(() => {
    fetchSignIndata();
  }, 5000); // 5000ms = 5 seconds

  // Cleanup the interval when the component unmounts
  return () => clearInterval(interval);
}, [fetchSignIndata]); 

 useEffect(()=>{
fetchSignIndata()
 },[RoomCardData])
// Triggered only when RoomCardData is updated

  const handleResignRoom = async ({ appointmentid, pateintID, roomType, roomName ,appointmentdate, visit_confirmation  }) => {
    console.log('Appointmentdate',appointmentdate)
    const payload = {
      room_no: roomName, // Room number
      appointment_id: appointmentid, // Appointment ID
      appointment_date: dayjs(appointmentdate).format("YYYY-MM-DD"),
      visit_confirmation:  visit_confirmation ?  visit_confirmation: "Ready for Provider",
    };

    try {
      const response = await api.put(`/v1/${practiseid}/checkin/patient/${pateintID}/update-data`, payload);
      if (response.status === 200) {
        // Handle success response
        // Close the popup or navigate back
        await fetchSignIndata();
      } else {
        console.error("Failed to assign room");
      }
    } catch (error) {
      console.error("Error assigning room:", error);
    }
  };

  const handlePateintsModalClose = () => {
    setOpenPatients(false);  // Close modal when triggered
  };

  const handlePatientsModalOpen = (patientsData, e) => {
    e.stopPropagation(); // Prevent click event from propagating
    setPatients(patientsData);  // Set the patients data for the modal
    setOpenPatients(true);  // Open the modal
  };

  const handleUnassignPateint = async ({ Pateints }) => {
    const PateintID = Pateints.patientid;
    try {
      const response = await api.post(`/v1/${practiseid}/checkin/patient/${PateintID}/unassign`, {
        appointment_id: Pateints.appointmentid,
        token: Pateints.token,
        roomno: Pateints.roomno,
        rowid: Pateints.rowid
      });
      if (response.status === 200) {
        fetchRoomData();
        handlePateintsModalClose();
      } else {
        console.error("Failed ");
      }
    } catch (error) {
      console.error("Error unassigning room:", error);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      let newGridWidth = width;
      let newCols;

      if (width >= 1290) {
        newGridWidth = 3000; // Set larger width for desktop
        newCols = 40;
      } else if (width >= 1024) {
        newGridWidth = 1800; // Set width for large screens (laptops/tablets)
        newCols = 26;
      } else {
        newGridWidth = 830; // Set width for smaller screens
        newCols = 12;
      }

      setGridWidth(newGridWidth);
      setCols(newCols);
    };

    // Call handleResize to set the initial width on load
    handleResize();

    // Attach resize event listener
    window.addEventListener('resize', handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 

  const gridLayoutStyles = {
    visibility: initialRenderComplete ? 'visible' : 'hidden',
    transition: 'opacity 0.2s ease-in-out',
    opacity: initialRenderComplete ? 1 : 0
  };
  
  const handleSettingsClick=()=>{
    setSettingsModal(true)
  }

  const getTimeDifference = (signInTime) => {
  
    // Check if the signInTime is a valid Date, if it's a string, parse it into a Date object
    if (!(signInTime instanceof Date)) {
      signInTime = new Date(signInTime); // Convert string to Date if necessary
    }
  
    // Check if signInTime is valid
    if (isNaN(signInTime.getTime())) {
      console.error('Invalid signInTime');
      return NaN; // Return NaN if the signInTime is invalid
    }
  
    // Set options for CST timezone
    const options = { timeZone: 'America/Chicago', hour12: false }; 
  
    // Get current date in CST
    const currentDateCST = new Date(new Date().toLocaleString('en-US', options));
  
    // Calculate the difference in milliseconds
    const diffInMs = currentDateCST - signInTime; // Difference in milliseconds
  
    // Convert milliseconds to minutes
    const diffInMins = diffInMs / (1000 * 60); 
    return diffInMins;
    
  };
  
  
  

const handleColorGet = async () => {
   
  try {
    const response = await api.get(`/v1/${practiseid}/rooms/get_room_settings?tab_name=rooms`);
    if (response.status === 200) {
      setOccupied(response.settings.occupied_color )
      setAvailable(response.settings.available_color)
      setThreshold(response.settings.alarm)
      setContainerAlignment(response.settings.room_alignment)
      setFontSize(response.settings.font_size);
      await fetchSignIndata();
    } else {
      console.error("Failed to assign room");
    }
  } catch (error) {
    console.error("Error assigning room:", error);
  }
};

useEffect(()=>{
handleColorGet()
},[])

const getFontSizeClass = (fontsize) => {
  switch (fontsize) {
    case 'lg':
      return 'text-lg';  // large font
    case 'md':
      return 'text-base'; // medium font
    case 'sm':
      return 'text-sm';  // small font
    case 'xs':
    default:
      return 'text-xs';  // extra small font
  }
};


const handleAlarmData= async({PateintData},AlarmData)=>{
  try {
    const response = await api.put(`/v1/${practiseid}/checkin/patient/${PateintData.patientid}/update_alarm_alert`,{
      appointment_id:PateintData.appointmentid,
      alarm_alert: AlarmData
    });
    if (response.status === 200) {
      handlePateintsModalClose()
      fetchSignIndata();
    } else {
      console.error("Failed ");
    }
  } catch (error) {
    console.error("Error unassigning room:", error);
  }
}
useEffect(() => {
  const emergencyPatients = [];

  rooms.forEach((room) => {
    const patientWithEmergency = room.patients.find(patient => 
      patient.emergencyalert !== "false" && patient.emergencyalert !== "False" && patient.emergencyalert
    );
    
    if (patientWithEmergency) {
      emergencyPatients.push({
        patientName: `${patientWithEmergency.firstname} ${patientWithEmergency.lastname}`,  // Assuming `name` is the property for patient name
        roomName: room.name
      });
    }
  });

  // Update state with the list of patients requiring emergency assistance
  setPatientsWithEmergency(emergencyPatients);
  
}, [rooms]);
const roomHelp = openHelpRequests(rooms);
const [closingHelp, setClosingHelp] = useState(null);
const handleHelpDone = async (appointmentid) => {
  setClosingHelp(appointmentid);
  try {
    await closeRoomHelp(practiseid, appointmentid);
    fetchSignIndata();
  } catch (error) {
    console.error("Could not close the help request");
  } finally {
    setClosingHelp(null);
  }
};

  return (
    
      <div className={`p-3 min-h-screen h-auto ${darkMode ? 'bg-[black] text-white' : ''}`}>
       <div className="relative font-bold mb-2 flex w-full justify-between items-center">
        <div className="flex gap-4 items-center">
          <div onClick={() => navigate(-1)}>
            <ArrowBackIosIcon className="cursor-pointer opacity-0 hover:opacity-100 transition-opacity" />
          </div>
          {darkMode?<img src={DarkBrainymedLogo} className={`${isFullscreen?"w-80":"w-48"} rounded`} alt="%" />:<img src={BrainymedLogo} className={`${isFullscreen?"w-80":"w-48"} rounded`}  alt="%" />} 
          <div
            onClick={isFullscreen ? exitFullscreen : enterFullscreen}
            className="bg-gray-200 text-sm text-white py-1 px-1 rounded-full cursor-pointer opacity-0 hover:opacity-100 transition-opacity"
          >
            {isFullscreen ? <CropFreeIcon  style={{ color: 'black' }} /> : <CropFreeIcon style={{ color: 'black' }} />}
          </div>
        </div>
           {roomHelp.length > 0 && (
             <div className={`absolute ${isFullscreen?'left-[34%] ':"left-[30%] "} ${patientsWithEmergency.length ? 'top-[110%]' : 'top-[0%]'} w-[40%] flex flex-col gap-1 z-10`} data-testid="room-help-badges">
               {roomHelp.map((h) => (
                 <div key={h.appointmentid} className="flex items-center justify-between border-[1.5px] border-amber-300 bg-[#FFFBEB] rounded-[10px] py-2 px-4 font-inter text-[#B45309]">
                   <span><NotificationsActiveIcon sx={{marginBottom:'3px', fontSize: 20}}/> Help requested · Room {h.roomName}</span>
                   <button type="button" disabled={closingHelp === h.appointmentid}
                     className="ml-3 px-3 py-0.5 rounded-full bg-[#B45309] text-white text-sm disabled:opacity-50"
                     onClick={() => handleHelpDone(h.appointmentid)}>Done</button>
                 </div>
               ))}
             </div>
           )}
           <div>  {patientsWithEmergency&&patientsWithEmergency.map((item, index) => (
             <div className={`absolute ${isFullscreen?'left-[34%] ':"left-[30%] "} border-[1.5px] border-gray-200 top-[0%] w-[40%] bg-[#FEF2F2] rounded-[10px] w-[100%] py-2 font-inter text-[#DC2626] px-4`} key={index}><ErrorOutlineIcon sx={{marginBottom:'5px'}}/> URGENT ASSISTANCE NEEDED IN ROOM {item.roomName}</div>
              ))}
             </div>
        <div>
          <div className="flex">
            <div></div>
          <DynamicTime />
          </div>
        </div>
      </div>
      
      {toggleroom && 
        <div className="flex justify-between items-center mb-2">
          <button
            className="px-4 py-2 bg-[#50869A] text-white rounded-full"
            onClick={openModal}
          >
            + Add Room
          </button>
        </div>
      }

      <div className={`flex w-full gap-4    ${containerAlignment==='right'?'':"justify-center"}`}>
      <style>
  {`
    .grid-container {
      position: relative;
      border:${isEditing?'1.5px solid #E17954':"1px solid #ddd"};
      transition: background 0.3s ease; /* Smooth transition when switching backgrounds */
    }

    .grid-container.dragging {
            background-image: linear-gradient(90deg, ${
        darkMode ? '#333333' : '#ddd'
      } 1px, transparent 1px),
                        linear-gradient(0deg, ${
                          darkMode ? '#333333' : '#ddd'
                        } 1px, transparent 1px);

      background-size: 40px 40px; /* Size of the grid lines */
      background-position: 0 0, 0 0;
    }

    .room-card {
      max-width: 600px;
      max-height: 600px;
      width: 100%;
      height: auto;
    }
  `}
</style>

        
        {/* First column - Grid Container */}
        <div
        style={{backgroundColor:darkMode?'#191919':'#f9f9f9'}}
        className={`grid-container   relative rounded-[10px] h-[600px] 2xl:h-[800px] ${containerAlignment==='right'?"w-[75%] lg:w-[75%] xl:w-[75%] 2xl:w-[75%]":"w-[85%] lg:w-[85%] xl:w-[85%] 2xl:w-[85%]"}  custom-scrollbar overflow-y-hidden hover:overflow-y-auto overflow-x-hidden hover:overflow-x-auto ${
    isDragging ? 'dragging' : ''
  }`}
>          <div style={gridLayoutStyles}>
            <GridLayout
           
              className="layout"
              layout={rooms.map((room) => ({
                i: room.id.toString(),
                x: room.x,
                y: room.y,
                w: room.w,
                h: room.h,
                // static: !isEditing,
              }))}
              cols={cols} 
              rowHeight={50}
              width={gridWidth}
              onLayoutChange={onLayoutChange}
              isDraggable={isEditing}
              isResizable={isEditing}
              margin={[8, 8]}
              preventCollision={true}
              compactType={null}
              onDragStart={() => setIsDragging(true)}
  onDragStop={(newLayout) => {
    setIsDragging(false);
    onDragStop(newLayout); // Ensure layout updates when drag stops
  }}
  onResizeStart={() => setIsDragging(true)}
  onResizeStop={(newLayout) => {
    setIsDragging(false);
    onResizeStop(newLayout); // Ensure layout updates when resize stops
  }}
            >
              {rooms.map((room) => (
                <div
                  key={room.id}
                  className={`room-card relative ${
                    room.patients && room.patients.length > 0
                      ? `bg-[${getoccupied}]  text-white`
                      : room.is_active === "N"
                      ? 'bg-[#E5E7EB] text-gray-400'
                      : `bg-[${getavailable}] text-white`
                  }
                  // min-h-[100px] min-w-[100px] max-w-[200px]  2xl:min-h-[110px]
                  ${getFontSizeClass(fontSize)}   whitespace-normal break-words rounded-[10px] ${darkMode?'border-2 border-[#333333]':'border-2'}  p-1 flex flex} min-h-[100px] min-w-[100px] max-w-[200px] whitespace-normal break-words rounded-[10px] p-1 flex flex-col ${room.patients.length === 0 ? 'justify-end' : 'justify-between'} items-center ${
                    selectedRoom === room.id ? 'border-yellow-300 border-2' : ''
                  } ${room.patients.some(patient => patient.emergencyalert==='true') ? 'emergency-alert-border' : ''}`}
                  style={{
                    backgroundColor: darkMode
                      ? room.patients.length > 0
                        ? getoccupied // Occupied room color in dark mode
                        : room.is_active === "N"
                        ? '#E5E7EB' // Inactive room color in dark mode
                        : '#374151CC' // Custom dark color for available rooms in dark mode
                      : room.patients.length > 0
                      ? getoccupied // Occupied room color in light mode
                      : room.is_active === "N"
                      ? '#E5E7EB' // Inactive room color in light mode
                      : getavailable, // Available room color in light mode
                  }}
                
                
                  onClick={(e) => handleRoomClick(room,e)}
                >
                  <style>
  {`
.emergency-alert-border {
  border: 2px solid yellow;
  animation: wave-border 1s infinite;
}

@keyframes wave-border {
  0% {
    border-color: yellow;
  }
  50% {
    border-color: transparent;
  }
  100% {
    border-color: yellow;
  }
}

  `}
                  </style>
                  {room.patients && room.patients.length > 0 && 
                    <div className="flex w-full justify-end mb-1 cursor-pointer">
                      <MoreVertIcon 
                        onClick={(e) => handlePatientsModalOpen(room.patients, e)} 
                        className="mb-1" 
                        style={{ width: "20px" }} 
                      />
                    </div>
                  }
                  {room.patients && room.patients.length > 0 && (
                    <div className={`${getFontSizeClass(fontSize)} font-inter`}>
                      {room.patients.map((patient) => {
                           const timeDiff = getTimeDifference(patient.signintime);
                           return (
                        <div key={patient.id} className="flex items-center my-1 justify-between">
                          <div className="absolute top-4 left-4 flex flex-col  items-center" >
                            <div className="flex font-inter  text-left">{patient.lastname.slice(0, 3)}, {patient.firstname.charAt(0)}</div>
                            <div className="ml-[2px] ">{patient.patientid}</div>
                            {patient.providercheck==='true'&&<div className={`absolute ${getFontSizeClass(fontSize)} left-16 top-4 border-[1.5px] rounded-full p-[3px] border-[white]`}> {patient.providerfirstname.charAt(0)}{patient.providerlastname.charAt(0)}</div>}
                            {threshold !== null && patient.signintime && timeDiff > threshold && (
                                <div className={`absolute top-12 left-[-10px]  ${darkMode?'text-white':"text-black"} ml-2`}>
                                   {<NotificationsActiveIcon   style={{height:'18px'}} /> } 
                                   {patient.alarmtime !== "false"  && <span className="flashing-dot"></span>}
                                   <style>
        {`
          .flashing-dot {
            width: 4px; /* Decreased size */
            height: 4px; /* Decreased size */
            border-radius: 50%;
            background-color: red; /* You can change the color */
            position: absolute;
            top: 8px;
            left: 28px; /* Adjust to position the dot relative to the icon */
            animation: blink 1s infinite alternate, wave 1.5s infinite ease-out;
          }

          @keyframes blink {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes wave {
            0% {
              transform: translate(-50%, -50%) scale(1);
              box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5);
            }
            100% {
              transform: translate(-50%, -50%) scale(1.5); /* Adjust the size of the wave */
              box-shadow: 0 0 15px 5px rgba(255, 0, 0, 0.3); /* Adds the wave glow effect */
            }
          }
        `}
      </style>
                                   </div>
                           )}
                          </div>
                         {/* Bell icon appears only if the timeDiff exceeds the threshold and threshold is set */}
                       
                          </div>)
                      })}
                    </div>
                  )}
                  <div className="flex w-full justify-end px-1 mb-1">
                    <span className="cursor-move font-inter text-md">{room.name.slice(0,7)}</span>
                  </div>
                  {isEditing  && (
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-0 hover:opacity-100 transition-opacity duration-300">
                      <button 
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent event propagation
                          handleEditRoom(room, e);
                        }} 
                        className="bg-black bg-opacity-50 p-2 rounded-full text-white"
                      >
                        <FaEdit />
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </GridLayout>
            <div className="absolute flex flex-col  left-2 top-2 mb-2">
              <div
                onClick={toggleEditingMode}
                className={`rounded-full border-white outline-none p-2 text-gray-500 flex items-center opacity-0 hover:opacity-100   transition-opacity`}
              >
                {isEditing ? <EditOffIcon className="mr-2 cursor-pointer" /> : <ModeEditIcon className="mr-2 cursor-pointer" />}
              </div>
              <div>
                <SettingsIcon onClick={()=>handleSettingsClick()} className={`mr-2 text-gray-500  opacity-0 hover:opacity-100 transition-opacity`}/>
              </div>
            </div>
          </div>
        </div>
        
        {/* Second column - In-Office section */}
         {containerAlignment==='right' && (<div className="w-[30%] 2xl:w-[23%] flex flex-col">
          <div className="w-full">
            <div className={`${getFontSizeClass(fontSize)} text-left items-center px-1 flex w-full justify-between`}>
              <div className={`font-semibold ${darkMode?'text-white':""} font-inter text-[#1D2951]`}>
            WAITING ROOM
            </div>
            <div className={`px-2 font-inter font-semibold h-[23px] flex items-center ${darkMode?'bg-[white]  text-black':"bg-[#626262]  text-white"} text-[14px] rounded-[2px]`}>  
               {data.filter((x) => x.visit_confirmation === "Ready for Triage" &&  (x.room_no === '' || x.room_no === null || x.room_no === 0)).length}
            </div>
          </div>
            <div className={`w-[100%] flex flex-col gap-2 p-1 ${darkMode?"":"bg-gray-50"} rounded-[10px] max-h-[474px] 2xl:max-h-[580px] custom-scrollbar overflow-y-hidden hover:overflow-y-auto`}>
  {data.filter((x) => x.visit_confirmation === "Ready for Triage" && (x.room_no === '' || x.room_no === null || x.room_no === 0)).length === 0 && (
    <div className={`flex justify-center ${darkMode?"border border-[#333333]":"border-2 "}  w-[auto] my-2  p-2 rounded ${getFontSizeClass(fontSize)} text-gray-500 whitespace-nowrap`}>
      No data found!
    </div>
  )}

  {(() => {
    // Filtered data with the desired condition
    const filteredData = data.filter((x) => x.visit_confirmation === "Ready for Triage" && (x.room_no === '' || x.room_no === null || x.room_no === 0));

    return filteredData.map((x) => (
      <div
      key={x.id}
      onClick={() => handlePatientClick(x)}
      className={` ${selectedPatientId === x.id ? 'bg-yellow-200 text-black' : ''} ${darkMode?'border-0 bg-[#374151CC]':'border-[1.5px]'}  cursor-pointer border-gray-200 rounded-[10px] px-2 py-[14px]`}
    >
      <div className="flex">
        <div className="bg-[#E17954] w-[40px] text-white text-xs rounded-full flex items-center justify-center">
          {x.token}
        </div>
        <div className={`flex items-center  ${fontSize==='lg'?"text-md":getFontSizeClass(fontSize)} px-2 w-[110px]`}>
          <div className="flex font-inter  text-left whitespace-nowrap">{x.lastname.slice(0, 3)}, {x.firstname.charAt(0)}</div>
          <div className="flex font-inter  ml-1 text-gray-500 items-center">
            {x.patientid}
          </div>
        </div>
        <div className="flex justify-between w-full">
        <div className={`text-xs flex font-inter border-[1.5px] ${x.purpose === 'FOLLOW UP' ? (darkMode ? 'border-[#9CA3AF] text-[#9CA3AF]' : 'border-[#000000] text-[#166534]') : 
x.purpose === 'WALK IN' ? 'border-[#C20CA1] text-[#C20CA1]' : 
x.purpose === 'NEW PT' ? 'border-[#000000] text-[#4B5563]' : 
darkMode ? 'border-[#9CA3AF] text-[#9CA3AF]' : 
'border-[#000000] text-[#000000]'} rounded-full px-2 ml-3 text-center items-center whitespace-nowrap`}>
{
x.purpose === 'FOLLOW UP' 
? 'F/U' 
: x.purpose === 'FOLLOW UP MCAR' 
? 'F/U MCAR' 
: x.purpose.length > 8 
? `${x.purpose.slice(0, 6)}...` 
: x.purpose
}
</div>

        <div className={`flex font-inter text-xs mt-2`}>
{ x.linked_provider}
          </div>
        </div>
      </div>
    </div>
    ));
  })()}
            </div>
          </div>
        </div>)}
      </div>

      {/* Patient Queue Section */}
     {containerAlignment==='bottom'&&( <div className={`w-full   ${darkMode ? 'bg-[black] text-white' : 'bg-gray-50'} mt-2 h-auto  `}>
       <div className="flex w-full justify-center items-center ">
         <div className={`${getFontSizeClass(fontSize)} text-left px-1 flex w-[15%] justify-between`}>
              <div className={`font-semibold ${darkMode?'text-white':""} font-inter text-[#1D2951]`}>
            WAITING ROOM
            </div>
            <div className={`px-2 font-inter font-semibold  h-[23px] flex items-center ${darkMode?'bg-[white] text-black':"bg-[#626262] text-white"}  text-[14px] rounded-[2px]`}> 
               {data.filter((x) => x.visit_confirmation === "Ready for Triage" &&  (x.room_no === '' || x.room_no === null || x.room_no === 0)).length}
            </div>
          </div>
          </div>

        <div className="flex gap-2 min-w-[full] h-auto p-1 rounded-[10px] custom-scrollbar overflow-x-hidden hover:overflow-x-auto">
          <div className="flex gap-2">
            {data.filter((x) => x.visit_confirmation === "Ready for Triage" &&  (x.room_no === '' || x.room_no === null || x.room_no === 0)).length === 0 && (
              <div className="flex justify-start w-[auto] my-2 border-2 p-2 rounded text-lg text-gray-500 whitespace-nowrap">
                No data found!
              </div>
            )}

            {(() => {
              // Filtered data with the desired condition
              const filteredData = data.filter((x) => x.visit_confirmation === "Ready for Triage" && (x.room_no === '' || x.room_no === null || x.room_no === 0));

              // Chunking data into groups of 3 to fill columns properly
              const chunkedData = [];
              for (let i = 0; i < filteredData.length; i += 3) {
                chunkedData.push(filteredData.slice(i, i + 3));
              }

              return chunkedData.map((chunk, columnIndex) => (
                <div key={columnIndex} className="flex flex-col gap-2 w-[100%]">
                  {chunk.map((x) => (
                    <div
                      key={x.id}
                      onClick={() => handlePatientClick(x)}
                      className={` ${selectedPatientId === x.id ? 'bg-yellow-200 text-black' : ''}  ${darkMode?'border-0 bg-[#374151CC]':'border-[1.5px]'}  cursor-pointer border-gray-200 rounded-[10px] px-2 py-[14px]`}
                    >
                      <div className="flex">
                        <div className="bg-[#E17954] w-[40px] mr-2 px-1 text-white text-xs rounded-full flex items-center justify-center">
                          {x.token}
                        </div>
                        <div className={`flex items-center  ${fontSize==='lg'?"text-md":getFontSizeClass(fontSize)} px-2  ${fontSize==='lg'?'w-[140px]':"w-[110px]"}`}>
                          <div className="flex font-inter  text-left whitespace-nowrap">{x.lastname.slice(0, 3)}, {x.firstname.charAt(0)}</div>
                          <div className="flex font-inter  ml-1 text-gray-500 items-center">
                            {x.patientid}
                          </div>
                        </div>
                        <div className="flex justify-between w-full">
                        <div className={`text-xs flex font-inter border-[1.5px] ${x.purpose === 'FOLLOW UP' ? (darkMode ? 'border-[#9CA3AF] text-[#9CA3AF]' : 'border-[#000000] text-[#166534]') : 
                x.purpose === 'WALK IN' ? 'border-[#C20CA1] text-[#C20CA1]' : 
                x.purpose === 'NEW PT' ? 'border-[#000000] text-[#4B5563]' : 
                darkMode ? 'border-[#9CA3AF] text-[#9CA3AF]' : 
                'border-[#000000] text-[#000000]'} rounded-full px-2 ml-3 text-center items-center whitespace-nowrap`}>
  {
    x.purpose === 'FOLLOW UP' 
      ? 'F/U' 
      : x.purpose === 'FOLLOW UP MCAR' 
      ? 'F/U MCAR' 
      : x.purpose.length > 8 
      ? `${x.purpose.slice(0, 6)}...` 
      : x.purpose
  }
</div>

                          <div className="flex font-inter text-xs mt-2 ml-4">
                          {/* {x.linked_provider.length > 6 ? `${x.linked_provider.slice(0, 8)}...` : x.linked_provider} */}

  { x.linked_provider}
</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ));
            })()}
          </div>
        </div>
      </div>)}

      {/* Toast Message and Backdrop Components */}
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
        <CenterToastMessage
        message={toastCenterMessage}
        severity={toastCenterSeverity}
        open={openCenterToast}
        handleClose={handleToastCenterClose}
      />
      <Backdrop
        sx={{
          color: 'secondary.main',
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      
      {/* Modals */}
      {openPatients && 
        <Unassignp 
          handleUnassignPateint={handleUnassignPateint} 
          fetchRoomData={fetchRoomData}   
          fetchSignIndata={fetchSignIndata} 
          Patients={Patients} 
          handlePateintsModalClose={handlePateintsModalClose} 
          darkMode={darkMode}
          handleAlarmData={handleAlarmData}
          setAlarmReset={setAlarmReset}
          alarmReset={alarmReset}
        />
      }
      
      {modalPateintOpen && 
        <PateintConfirm 
          fetchSignIndata={fetchSignIndata} 
          fetchRoomData={fetchRoomData} 
          AddedRoom={AddedRoom} 
          RoomData={RoomData} 
          handleUnassignPateint={handleUnassignPateint} 
          handleResignRoom={handleResignRoom}  
          currentRoomPatient={currentRoomPatient} 
          selectedPatientInroom={selectedPatientInroom} 
          setModalPateintOpen={setModalPateintOpen} 
          darkMode={darkMode}
        />
      }
      
      {isModalOpen && 
        <MemoizedAddRoom 
          fetchSignIndata={fetchSignIndata}  
          fetchRoomData={fetchRoomData} 
          setAddedRoom={setAddedRoom} 
          roomExistsError={roomExistsError} 
          closeModal={closeModal} 
          handleAddRoom={handleAddRoom} 
          handleSaveEdit={handleSaveEdit} 
          editingRoom={editingRoom} 
          setNewRoomName={setNewRoomName} 
          setNewRoomStatus={setNewRoomStatus} 
          newRoomName={newRoomName} 
          newRoomStatus={newRoomStatus}
          darkMode={darkMode}
        />
      }

      {settingsModal&& <Settings 
      threshold={threshold} 
      fetchSignIndata={fetchSignIndata}
        darkMode={darkMode}
         setDarkMode={setDarkMode}
         handleDarkModeChange={handleDarkModeChange} 
         setSettingsModal={setSettingsModal}
         coloravalaible={coloravalaible}
         setColorAvailable={setColorAvailable}
         coloroccupied={coloroccupied}
         setColorOccupied={setColorOccupied}
        handleColorGet={handleColorGet}
        setAvailable={setAvailable}
        setOccupied={setOccupied}
        getavailable={getavailable}
        getoccupied={getoccupied}
        setThreshold={setThreshold}
        fontSize={fontSize}
        setFontSize={setFontSize}
        containerAlignment={containerAlignment}
        setContainerAlignment={setContainerAlignment}
          />} 
        {/* {showModal && <Swaproom darkMode={darkMode} previousRoom={previousRoom} nextRoom={nextRoom} handleConfirmSwap={handleConfirmSwap} handleCancelSwap={handleCancelSwap} />}    */}

    </div>
  );
};

export default Waitinghome;